import { css } from '@emotion/react';
import { tokens } from '@flysas-tech/commercial-ui';

const getStyles = (color: string) => css`
  display: flex;
  gap: 2px;

  > span {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${color};
    opacity: 0;
    animation: sas-loading 1s cubic-bezier(0.46, 0.07, 0.97, 0.54) infinite alternate;

    &:nth-of-type(2) {
      animation-delay: 0.3333s;
    }

    &:nth-of-type(3) {
      animation-delay: 0.6666s;
    }
  }

  @keyframes sas-loading {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export function LoadingIndicator({ color }: { color?: string }) {
  const c = color || tokens.color.brand;
  return (
    <div css={getStyles(c)}>
      <span />
      <span />
      <span />
    </div>
  );
}
